<template>
  <div class="container d-flex justify-content-center">
    <div class="card p-4">
      <h2 class="text-center">Uploader Dashboard</h2>
      <div class="d-grid gap-3 mt-4">
        <router-link to="/youtube" class="btn btn-primary module-btn">YouTube Uploader</router-link>
        <router-link to="/twitter" class="btn btn-info module-btn">Twitter Uploader</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home"
}
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
body {
  background: #f8f9fa;
}
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.module-btn {
  min-width: 200px;
}
.container {
  margin-top: 50px;
}
</style>